<!-- 自定义 MessageBox 组件 -->
<template>
  <div class="policy-dialog" v-show="isShowMessageBox">
    <div class="policy-dialog-con">
      <div class="policy-body">
          <div class="dialog-header">
            <h3>Our Privacy Statement &amp; Cookie Policy</h3>
            <a class="dialog-close" @click="cancel"></a>
          </div>
          <div class="dialog-content">
            By continuing to browse our site you agree to our use of cookies,
            revised Privacy Policy and Terms of Use. You can change your cookie
            settings through your browser.
          </div>
          <ul class="dialog-links">
            <li>
              <a
                href="https://www.cgtn.com/privacy"
                target="_blank"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                href="https://www.cgtn.com/terms-of-use"
                target="_blank"
                ><span>Terms of Use</span></a
              >
            </li>
          </ul>
          <div class="dialog-clear"></div>
          <div class="dialog-confirm" @click="confirm">
            <span class="confirm-icon"></span><span>I agree</span>
          </div>
        </div>
    </div>
  </div>
</template>
 
<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题",
    },
    content: {
      type: String,
      default: "这是弹框内容",
    },
    link: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {},
  data() {
    return {
      isShowMessageBox: true,
    };
  },
  methods: {
    // 确定,将promise断定为resolve状态
    confirm: function () {
      this.isShowMessageBox = false;
      localStorage.setItem('cgtnradio_isPrivacy','1');
      // this.remove();
    },
    // 取消,将promise断定为reject状态
    cancel: function () {
      this.isShowMessageBox = false;
      // this.remove();
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox: function () {
      if(localStorage.getItem('cgtnradio_isPrivacy') != null){
        this.isShowMessageBox = false;
      }else{
        this.isShowMessageBox = true;
      }
    },
    remove: function () {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy: function () {
      this.$destroy();
      document.body.removeChild(this.$el);
    },
  },
  created() {
    
  },
  mounted() {
    
  },
};
</script>
 
<style scoped lang="scss">
.policy-dialog {
  position: relative;
  .policy-dialog-con {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10000;
    background-color: #fff;
    box-shadow: 0 -7px 20px 0 rgba(0,0,0,.19);
    .policy-body{
        font-size: 13px;
        position: relative;
        margin: 48px auto;
        width: 1536px !important;
        .dialog-header{
          position: relative;
          h3{
            font-size: 16px;
            color: #333;
            font-weight: bold;
          }
          a{
            position: absolute;
            right: 0;
            top: 0;
            width: 14px;
            height: 14px;
            background: url('../../../../static/img/close.png') no-repeat;
            background-size: 14px 14px;
            cursor: pointer;
          }
        }
        .dialog-content{
          margin: 17px 0;
          width: 800px;
        }
        .dialog-links{
          width: 100%;
          li{
            float: left;
            margin-right: 32px;
            a{
              color: #bfae61;
              font-weight: 400;
              position: relative;
              &::after{
                position: absolute;
                height: 1px;
                margin: 0 auto;
                content: '';
                left: 0;
                right: 0;
                width: 100%;
                color: #bfae61;
                background-color: #bfae61;
                left: 0;
                bottom: -1px;
              }
            }
          }
        }
        .dialog-confirm{
          width: 122px;
          height: 42px;
          color: #bfae61;
          border: 1px solid #bfae61;
          position: absolute;
          right: 0;
          bottom: 0;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          .confirm-icon{
            width: 17px;
            height: 12px;
            background: url('../../../../static/img/icon_agree.png') no-repeat;
            background-size: 17px 12px;
            margin-right: 16px;
            display: inline-block;
            vertical-align: sub;
          }
        }
        .dialog-clear{
          clear: both;
        }
        
      }
  }
}

@media screen and (max-width: 1560px) and (min-width: 1261px) {
  .policy-dialog {
    position: relative;
    .policy-dialog-con {
      .policy-body{
        width: 1248px !important;
        }
    }
  }
}

@media screen and (max-width: 1260px) and (min-width: 769px) {
  .policy-dialog {
    position: relative;
    .policy-dialog-con {
      .policy-body{
        width: 768px !important;
        margin: 28px auto;
        padding: 0 16px;
          .dialog-content{
            width: 600px;
          }
          .dialog-confirm{
            height: 28px;
            line-height: 28px;
            width: 90px;
            right: 16px;
          }
        }
    }
  }
}
@media screen and (max-width: 768px) {
  .policy-dialog {
    position: relative;
    .policy-dialog-con {
      .policy-body{
        font-size: .6rem;
        width: 100% !important;
        margin: 1rem auto;
        padding: 0 .83rem;
          .dialog-header{
            h3{
              font-size: 100%;
            }
            a{
              position: absolute;
              right: 0;
              top: 0;
              width: 0.6rem;
              height: 0.6rem;
              background: url('../../../../static/img/close.png') no-repeat;
              background-size: .6rem .6rem;
              cursor: pointer;
            }
          }
          .dialog-content{
            margin: 1rem .6rem 1rem 0;
            width: 100%;
          }
          .dialog-confirm{
            width: 4.2rem;
            height: 1.2rem;
            line-height: 1.2rem;
            right: .7rem;
            align-items: center;
            .confirm-icon{
              background-size: 0.6rem 0.6rem;
              width: 0.6rem;
              height: 0.6rem;
              margin-right: 0.4rem;
            }
          }
          .dialog-links{
            li{
              margin-right: 1.2rem;
              a{
                font-size: 100%;
              }
            }
          }
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/policy-dialog/index.vue